import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
export function OfferSection() {
  return <div className="grain-section w-full bg-page-bg px-6 py-20 md:py-28" data-id="element-236" data-mp="3o2cl1kw56le">
      <div className="max-w-6xl mx-auto" data-id="element-237" data-mp="3lzdzt5oa552">
        {/* Chapter 6 */}
        <div className="space-y-16" data-id="element-238" data-mp="8lu805kqvauc">
          <div className="flex flex-col md:flex-row md:items-center gap-8 mb-8" data-id="element-239" data-mp="de54szk6ugio">
            <div className="text-8xl md:text-9xl font-black text-black/5 font-sans tracking-tighter" data-id="element-240" data-mp="dg86whym803r">
              06
            </div>
            <div className="h-px w-24 bg-black/10 hidden md:block" data-id="element-241" data-mp="meaclatangxd"></div>
            <div data-id="element-242" data-mp="mgo459ormb06">
              <p className="text-xs text-teal-600 font-bold tracking-widest uppercase mb-3" data-id="element-243" data-mp="re69kq3kq83f">
                Chapter Six
              </p>
              <h2 className="text-4xl md:text-6xl font-bold text-ink tracking-tight" data-id="element-244" data-mp="wbof06idu56o">
                Who This Is For <br data-id="element-245" data-mp="2t6uceycb2tio" />
                <span className="text-teal-600" data-id="element-246" data-mp="2t7dy8q52u21z">(And Who It's NOT For)</span>
              </h2>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-12" data-id="element-247" data-mp="12n8lntatlwlo">
            <div className="bg-white rounded-[2.5rem] p-10 shadow-md border border-teal-100" data-id="element-248" data-mp="12otffgpb9bih">
              <h3 className="text-2xl font-bold text-teal-700 mb-8 flex items-center gap-3" data-id="element-249" data-mp="xv8sqkt643yl">
                <CheckIcon className="w-8 h-8" data-id="element-250" data-mp="sy8iryt76h27" /> This Advanced lite program is
                for you if:
              </h3>
              <ul className="space-y-4 text-lg text-ink-light" data-id="element-251" data-mp="ou0v84yh775k">
                <li className="flex gap-3" data-id="element-252" data-mp="1ll338vq0lgfo">
                  <span className="text-teal-500 font-bold" data-id="element-253" data-mp="1gn9x22opomfe">→</span> You've been
                  stuck despite trying multiple approaches
                </li>
                <li className="flex gap-3" data-id="element-254" data-mp="1ck4vc2cggort">
                  <span className="text-teal-500 font-bold" data-id="element-255" data-mp="17mlhh3jo6e0e">→</span> You've seen
                  specialists who couldn't figure out what's wrong
                </li>
                <li className="flex gap-3" data-id="element-256" data-mp="17ud2pvc8b1m">
                  <span className="text-teal-500 font-bold" data-id="element-257" data-mp="3scavxfggnxsk">→</span> You're
                  dealing with something "complex" or "treatment-resistant"
                </li>
                <li className="flex gap-3" data-id="element-258" data-mp="3ts6korfltqf5">
                  <span className="text-teal-500 font-bold" data-id="element-259" data-mp="2nya1gfnskt2">→</span> You want
                  PRECISION instead of guesswork
                </li>
                <li className="flex gap-3" data-id="element-260" data-mp="3kve07n6ojnar">
                  <span className="text-teal-500 font-bold" data-id="element-261" data-mp="3ou5207m3bt47">→</span> You're
                  ready to finally understand what's REALLY going on
                </li>
                <li className="flex gap-3" data-id="element-262" data-mp="3b1ot4q6id0vd">
                  <span className="text-teal-500 font-bold" data-id="element-263" data-mp="3fv9ums7b8czb">→</span> You're
                  willing to follow through on what you learn
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-[2.5rem] p-10 shadow-md border border-red-100" data-id="element-264" data-mp="363ndygc7dlp6">
              <h3 className="text-2xl font-bold text-red-700 mb-8 flex items-center gap-3" data-id="element-265" data-mp="2s4dv18wm4dhi">
                <XIcon className="w-8 h-8" data-id="element-266" data-mp="2x48kd80qov0g" /> This is NOT for you if:
              </h3>
              <ul className="space-y-4 text-lg text-ink-light" data-id="element-267" data-mp="2dhoxhclx8adr">
                <li className="flex gap-3" data-id="element-268" data-mp="2di70cs339mun">
                  <span className="text-red-500 font-bold" data-id="element-269" data-mp="28jdmuznsxvuh">→</span> You're just
                  looking for a magic pill
                </li>
                <li className="flex gap-3" data-id="element-270" data-mp="2mk6i5mlxguyn">
                  <span className="text-red-500 font-bold" data-id="element-271" data-mp="2ih9vnkt9oepf">→</span> You're not
                  willing to actually implement
                </li>
                <li className="flex gap-3" data-id="element-272" data-mp="2wf89mp3oe94e">
                  <span className="text-red-500 font-bold" data-id="element-273" data-mp="2rhpxyqy9xfsp">→</span> You expect
                  overnight results without doing the work
                </li>
                <li className="flex gap-3" data-id="element-274" data-mp="3662y804e9kt0">
                  <span className="text-red-500 font-bold" data-id="element-275" data-mp="317rmtkygb28o">→</span> You're not
                  ready to invest in yourself
                </li>
              </ul>
            </div>
          </div>

          <div className="text-center text-xl font-medium text-ink max-w-2xl mx-auto" data-id="element-276" data-mp="3a87r2wn0qdel">
            <p data-id="element-277" data-mp="3a6d2n8cjg35r">
              Be honest with yourself about where you're at. Because we're only
              taking a limited number of people. And we'd rather those slots go
              to people who are ready.
            </p>
          </div>
        </div>

      </div>
    </div>;
}